import React from 'react';

const LocationCard = ({ location, isSelected, onClick }) => {
  const progress = (location.speciesFound / location.totalSpecies) * 100;

  return (
    <div 
      onClick={onClick}
      className={`relative w-full h-48 sm:h-56 rounded-xl overflow-hidden cursor-pointer border-4 ${isSelected ? 'border-sage' : 'border-transparent'}`}
    >
      {/* Background Image */}
      <img
        src={location.image}
        alt={location.name}
        className="absolute inset-0 w-full h-full object-cover"
      />
      
      {/* Dark Overlay for Readability */}
      <div className="absolute inset-0 bg-black/40" />

      {/* Content */}
      <div className="absolute inset-0 p-4 flex flex-col justify-between text-white">
        <h3 className="font-heading font-bold text-xl tracking-wide text-left">{location.name}</h3>
        
        <div className="w-full">
          <div className="flex items-center justify-between text-sm mb-1 font-body font-medium text-gray-100">
            <span>{location.speciesFound}/{location.totalSpecies} arter</span>
            <span>{Math.round(progress)}%</span>
          </div>

          {/* Progress Bar */}
          <div className="w-full h-2 bg-white/30 rounded-full overflow-hidden border border-white/10">
            <div 
              className="h-full bg-leaf rounded-full"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationCard;
